import { CoreLogService } from "../log.service";
import { environment } from "../../../../environments/environment";
import { StatusBarTextStyle } from "../../shared/contentTypes";

declare var NavigationBar: any;

export interface ICordovaNavigationBar {
  backgroundColorByHexString(colorHex: string);
  backgroundColorByName(colorName: string);
  hide();
  show();
}

export class CordovaNavigationBar implements ICordovaNavigationBar {

  constructor(private _coreLogService: CoreLogService) {

  }

  public backgroundColorByHexString(colorHex: string): Promise<void> {
    const me = this;
    try {
      NavigationBar.backgroundColorByHexString(colorHex, me.setLightNavigationBar());
      return Promise.resolve();
    } catch (error) {
      me._coreLogService.error("CordovaNavigationBar", "backgroundColorByHexString()", error);
      return Promise.reject();
    }
  }

  public backgroundColorByName(colorName: string) {
    const me = this;
    try {
      NavigationBar.backgroundColorByName(colorName, me.setLightNavigationBar());
      return Promise.resolve();
    } catch (error) {
      me._coreLogService.error("CordovaNavigationBar", "backgroundColorByName()", error);
      return Promise.reject();
    }
  }

  public hide() {
    const me = this;
    try {
      NavigationBar.hide();
      return Promise.resolve();
    } catch (error) {
      me._coreLogService.error("CordovaNavigationBar", "hide()", error);
      return Promise.reject();
    }
  }

  public show() {
    const me = this;
    try {
      NavigationBar.show();
      return Promise.resolve();
    } catch (error) {
      me._coreLogService.error("CordovaNavigationBar", "show()", error);
      return Promise.reject();
    }
  }

  private setLightNavigationBar(): boolean {
    const isStatusBarTextStyleLight = (environment.StatusBarTextStyle === StatusBarTextStyle.styleDefault);
    if (isStatusBarTextStyleLight) {
      return true;
    } else {
      return false;
    }
  }
}
